import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { AuthService } from 'src/app/services/auth/auth.service';
import { AppConfigService } from 'src/app/services/appconfig/app-config.service';
import { ErrorHandlerService } from '../error-handler/error-handler.service';
import { catchError, map } from 'rxjs/operators';
import { throwError, Observable } from 'rxjs';
import { AppInsightsService } from 'src/app/services/common/appinsights.service';
//import { debug } from 'console';


@Injectable({
  providedIn: 'root'
})
export class AdminRequestService {
  private url: string;
  res:any;

  constructor(appConfigService: AppConfigService,
    private http: HttpClient,
    private appInsights: AppInsightsService) {
    
    this.url = appConfigService.get('apiUrl');

  }

  getBATRoles(): Observable<any> {
    
     return this.http.get(this.url + '/Master/GetBillingAdjustmentRoles').pipe(
      map(response => response as any),
      catchError(response => {
        this.appInsights.logException(response);
        return throwError(response);
      })
    );
    
}
    getRpfDetails(): Observable<any> {  
        return this.http.get(this.url + '/Master/GetRpfDetails').pipe(
          map(response => response as any),
          catchError(response => {
            this.appInsights.logException(response);
            return throwError(response);
          })
        );
    }

// getBATUserDetails(userId: string): Observable<any> {
//    return this.http.get(this.url + '/Master/GetUserRolesDetails'+ '/' + userId).pipe(
//    map(response => response as any),
//    catchError(response => {
//      this.appInsights.logException(response);
//      return throwError(response);
//    })
//  );
 
// }
getBATUserDetails(userId: string): Observable<any> {
   return this.http.get(this.url + '/Master/GetUserRolesDetails'+ '/' + userId).pipe(
   map(response => response as any),
   catchError(response => {
     this.appInsights.logException(response);
     return throwError(response);
   })
 );
 
}

getRoleDesc(): Observable<any> {
  
   return this.http.get(this.url + '/Master/GetBillingAdjustmentAllRolesDesc').pipe(
    map(response => response as any),
    catchError(response => {
      this.appInsights.logException(response);
      return throwError(response);
    })
  );
  
}

deleteUser(userId: number): Observable<any> {
  
   return this.http.delete(this.url + '/Master/DeleteBillingAdjustmentUserRole'+ '/' + userId).pipe(
    map(response => response as any),
    catchError(response => {
      this.appInsights.logException(response);
      return throwError(response);
    })
  );
  
}

submitAdminRoleRequest(params: any) {
  return this.http.post(this.url + '/Master/SubmitAdminRoleRequest', params).pipe(
    map(response => <any>response),
    catchError(response => {
      this.appInsights.logException(response);
      return throwError(response);
    })
  );
}

userRoles(params: any) {
  return this.http.post(this.url + '/Master/BATRolesByCloudID',params).pipe(
    map(response => <any>response),
    catchError(response => {
      this.appInsights.logException(response);
      return throwError(response);
    })
  );
}




} 
